import React from 'react';
import usePopover from '../../../hooks/usePopover';
import { LandingPopover } from './LandingPopover';
import { MarketPopover } from './MarketPopover';
import * as Styled from './styles';

const Popover = () => {
  const isLanding = window.Widget.settings.isLanding;
  const { state, getContainer } = usePopover();
  const { left, top, position, isHidden, data } = state;
  let subtitle;
  let text;
  let price;
  let prices;
  let statusIcon;
  let ticketType;
  let title;
  let isCategory;

  if (data) {
    ({ subtitle, price, prices, text, statusIcon, ticketType, title, isCategory } = data);
  }

  return (
    <Styled.Container
      ref={getContainer}
      top={top}
      left={left}
      position={position}
      style={{
        visibility: isHidden ? 'hidden' : 'visible',
        top: top && !isHidden ? `${top}px` : null,
        left: left && !isHidden ? `${left}px` : null,
        right: left ? 'unset' : null,
      }}
    >
      {isLanding ? (
        <LandingPopover
          price={price}
          prices={prices}
          statusIcon={statusIcon}
          ticketType={ticketType}
          subtitle={subtitle}
          text={text}
          isLanding={isLanding}
          title={title}
        />
      ) : (
        <MarketPopover
          price={price}
          prices={prices}
          statusIcon={statusIcon}
          ticketType={ticketType}
          subtitle={subtitle}
          text={text}
          isLanding={isLanding}
          title={title}
          isCategory={isCategory}
        />
      )}
    </Styled.Container>
  );
};

export default Popover;
